import useIntl from './useIntl';

function useFormatMessage() {
  const intl = useIntl();

  return intl?.formatMessage;
}

export default useFormatMessage;
